"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoReadyPickup = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.RoReadyPickup = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
    csa_name: typebox_1.Type.String(),
    prohibited_items_list: typebox_1.Type.String(),
    order_number: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    pickup_date: typebox_1.Type.String(),
    pickup_notes: typebox_1.Type.String(),
});
//# sourceMappingURL=ro-ready-pickup.js.map